import useHelpers from "composables/useHelpers";
import { storeToRefs } from "pinia";
import type { NavigationTab } from "shared/types";
import { useMenuStore } from "store/modules/menuStore.js";
import { computed, type ComputedRef } from "vue";

/**
 * Maps the menu store's sub-items for the active menu section to plain
 * NavigationTab entries (route mode), so NavigationTabs stays store-agnostic.
 */
export function useSubMenuTabs(): {
  subMenuTabs: ComputedRef<NavigationTab[]>;
} {
  const { generateMenuTitle } = useHelpers();

  const menuStore = useMenuStore();
  const { showSubItem } = menuStore;
  const { tabMenuItems } = storeToRefs(menuStore);

  const subMenuTabs = computed<NavigationTab[]>(() =>
    tabMenuItems.value
      .filter((subItem) => showSubItem(subItem))
      .map((subItem) => ({
        title: subItem.meta?.tabLabel || generateMenuTitle(subItem),
        value: String(subItem.name),
        sublabel: subItem.meta.sublabel
          ? generateMenuTitle(subItem, "sublabel")
          : undefined,
        to: { name: subItem.name },
      })),
  );

  return { subMenuTabs };
}
